import { FEATURE_FLAGS, type FlagKey } from './registry';

// One colour per flag, the same everywhere a flag is drawn: the legend pill, the border around
// each piece of UI the flag owns, the frame around the screen for a layout-wide flag. Assigned
// by the flag's place in the registry, so a flag keeps its colour from page to page and every
// flag on a page has its own; the registry holds at most 15 (registry.test.ts), one per entry.
// DESIGN-SYSTEM-EXCEPTION: dev-only flag tooling needs one colour per flag · expires 2027-01-21 · Austin Kempa
const PALETTE = [
  'hsl(0 72% 51%)', // red
  'hsl(199 89% 48%)', // sky
  'hsl(142 71% 45%)', // green
  'hsl(262 83% 58%)', // violet
  'hsl(24 94% 50%)', // orange
  'hsl(174 72% 40%)', // teal
  'hsl(330 81% 60%)', // pink
  'hsl(45 93% 47%)', // yellow
  'hsl(221 83% 53%)', // blue
  'hsl(85 70% 40%)', // lime
  'hsl(292 76% 55%)', // fuchsia
  'hsl(190 85% 40%)', // cyan
  'hsl(10 80% 45%)', // brick
  'hsl(240 60% 55%)', // indigo
  'hsl(160 70% 35%)', // emerald
] as const;

const KEYS = Object.keys(FEATURE_FLAGS);

export const flagColor = (key: FlagKey): string => {
  const index = KEYS.indexOf(key);
  return PALETTE[(index < 0 ? PALETTE.length - 1 : index) % PALETTE.length];
};
